<template>
	<div>
		<!-- 媒体数据 -->
		<div class="mianPage">
			<div class="topSearch space_between">
				<el-form inline class="el-form flex_start">
					<el-form-item>
						<el-date-picker v-model="datePicker" value-format="yyyy-MM-dd" type="daterange" range-separator="至"
							start-placeholder="开始日期" end-placeholder="结束日期" size="small" :clearable="false">
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-select v-model="queryData.mediaCompany" filterable clearable size="small" placeholder="请选择媒体公司"
						@change="companySelectChange">
							<el-option v-for="item in companyOptions" :key="item.value" :label="item.label" :value="item.label">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-select v-model="queryData.os" clearable size="small" placeholder="请选择操作系统">
							<el-option v-for="item in osOptions" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-select v-model="appSelectForm" clearable @change="appSeleteChange" size="small" value-key="value"
							popper-class="appNameIdOptions" :popper-append-to-body="false" filterable placeholder="请选择应用"
							:remote-method="appRemoteMethod" :loading="appRemoteLoading" remote @clear="getMediaAppOption()">
							<el-option v-for="item in mediaAppOptions" :key="item.value"
								:value="item" :label="`应用：${item.label} | ${item.value}`">
								<!-- :label="`应用：${item.label} | ${item.value}`" -->
								<div class="selectTemp2">
									<div class="selectAppName">{{item.label}}</div>
									<div class=""></div>
									<div class="selectAppId flex_start">
										<div>{{item.value}}</div>
										<img @click.stop="copyName(item.value)" src="../../assets/icon/copy.png" alt="" />
									</div>
								</div>
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-select v-model="queryData.type" clearable size="small" placeholder="请选择广告类型">
							<el-option v-for="item in adTypeOptions" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<!-- <el-input clearable size="small" placeholder="请输入聚合广告位" v-model="queryData.adsId"></el-input> -->
						<el-select v-model="adsSelectForm" clearable @change="adsSeleteChange" size="small" value-key="value"
							popper-class="appNameIdOptions" :popper-append-to-body="false" filterable @clear="getMediaAdsOption(2)"
							:remote-method="adsRemoteMethod" :loading="adsRemoteLoading" remote placeholder="请选择聚合广告位" style="width: 280px;">
							<el-option v-for="item in mediaAdsOptions" :key="item.value" :label="`广告位：${item.label} | ${item.value}`"
								:value="item">
								<div class="selectTemp2">
									<div class="selectAppName">{{item.label}}</div>
									<div class=""></div>
									<div class="selectAppId flex_start">
										<div>{{item.value}}</div>
										<img @click.stop="copyName(item.value)" src="../../assets/icon/copy.png" alt="" />
									</div>
								</div>
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-select v-model="queryData.appProperty" clearable size="small" placeholder="请选择应用属性">
							<el-option v-for="item in appPropertyOptions" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<!-- <el-form-item>
						<el-select v-model="queryData.platformId" clearable size="small" @change="networkOptionsChange" placeholder="请选择广告网络">
							<el-option v-for="item in networkOptions" :key="item.platformId" :label="item.label" :value="item.platformId">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-select v-model="queryData.platformNetworkId" clearable size="small"
						placeholder="请选择账号名称">
							<el-option v-for="item in accountOptions" :key="item.value" :label="item.label" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-select v-model="adsSelectFormChannel" clearable @change="channelAdsSeleteChange" size="small"
							value-key="value" popper-class="appNameIdOptions" :popper-append-to-body="false" filterable
							@clear="getChannelAdsOption(2)" :remote-method="channelAdsRemoteMethod" :loading="adsRemoteLoading" remote
							placeholder="请选择广告源" style="width: 280px;">
							<el-option v-for="(item,index) in channelAdsOptions" :key="index" :label="`广告源：${item.label} | ${item.value}`"
								:value="item">
								<div class="selectTemp2">
									<div class="selectAppName">{{item.label}}</div>
									<div class=""></div>
									<div class="selectAppId flex_start">
										<div>{{item.value}}</div>
										<img @click.stop="copyName(item.value)" src="../../assets/icon/copy.png" alt="" />
									</div>
								</div>
							</el-option>
						</el-select>
					</el-form-item> -->
				</el-form>
				<div class="searchMenuRight">
					<el-button type="primary" @click="confirmQuery" size="small"
						v-hasPermi="['dataReport:mediaData:query']">查询</el-button>
						<div></div>
					<el-button @click="searchReset" size="small" v-hasPermi="['dataReport:mediaData:query']">重置</el-button>
				</div>
			</div>
			<!-- table表格 -->
			<div class="tableBox">
				<div class="tHeadRow flex_start">
					<div class="tHeadleftTips">查看维度</div>
					<el-checkbox :indeterminate="isDimensionIndeterminate" v-model="dimensionCheckAll" @change="handleCheckAllChangeDim"
					style="margin-right: 30px;">全选</el-checkbox>
					<el-checkbox-group v-model="tHeaderQueryChecked" class="tHeadFixedCheckList">
						<el-checkbox v-for="(item,index) in tHeaderQueryData" :label="item.valueNum" size="mini"
							:checked="item.checked" :key="index" :name="item.value" class="check-box-fixed"
							@change="checkBoxQueryChange($event,item,index)">{{item.label}}
						</el-checkbox>
					</el-checkbox-group>
					<div class="tableBtns flex_start">
						<el-button @click="editTheadDialog" size="small"><i class="el-icon-setting"></i>
							自定义指标</el-button>
						<el-button type="primary" icon="el-icon-download" size="small" plain @click="appExport"
							v-hasPermi="['dataReport:mediaData:export']">导出</el-button>
					</div>
				</div>
				<div class="dimensionalityCheckedTips flex_start" v-if="hasChecked && hasRequiredPropsPUV">
					<img src="../../assets/icon/tipsIconTh.png" alt="" />
					<div>当前筛选条件下，不支持部分指标数据展现。</div>
				</div>
				<div class="dimensionalityCheckedTips flex_start" v-if="hasRequiredProps">
					<img src="../../assets/icon/tipsIconTh.png" alt="" />
					<div>通过报表API同步的数据存在T+1延迟，当日广告网络数据无法获取。</div>
				</div>
				<el-table :max-height="560" ref="tables" :header-cell-style="{color:'#333333',background:'#EAEFF5'}"
					:data="tableData" class="el_table" @expand-change="handleExpandChange" :row-class-name="tableRowClassName"
					@sort-change="sortChangeFun" :header-cell-class-name="handleHeadAddClass">
					<!-- :expand-row-keys="expandedRows" -->
					<el-table-column type="expand" fixed width="50">
						<template slot-scope="props">
							<el-table :data="props.row.tabList" class="el_tables"
								:header-cell-style="{color:'#333333',background:'#F6FEFF'}" @sort-change="(sortObj) => sortChangeFunSec(sortObj,props.row,props.$index)" 
								:header-cell-class-name="handleHeadAddClassSec">
								<!-- 展开表维度列宽需与父表一致，避免剩余宽度被 Element UI 二次分配 -->
								<el-table-column min-width="100" :fixed="shouldFixDimensionColumn"
								v-if="tHeaderQueryChecked.indexOf(1) !== -1"></el-table-column>
								<el-table-column prop="platformName" min-width="160" label="广告网络"
								v-if="tHeaderQueryChecked.indexOf(2) !== -1" :fixed="shouldFixDimensionColumn"></el-table-column>
								<el-table-column prop="" min-width="90" label="操作系统" v-if="tHeaderQueryChecked.indexOf(3) !== -1"
								:fixed="shouldFixDimensionColumn">
									<template slot-scope="scope">
										<div v-if="props.row.os">
											<div>{{props.row.os}}</div>
										</div>
										<div v-else>-</div>
									</template>
								</el-table-column>
								<el-table-column prop="" min-width="160" label="应用" v-if="tHeaderQueryChecked.indexOf(4) !== -1"
								:fixed="shouldFixDimensionColumn">
									<template slot-scope="scope">
										<div v-if="scope.row.platformAppId">
											<div>{{props.row.mediaAppName}}</div>
											<div style="color: #999999;">{{scope.row.platformAppId}}</div>
										</div>
										<div v-else>-</div>
									</template>
								</el-table-column>
								<el-table-column prop="" min-width="130" label="广告位类型" v-if="tHeaderQueryChecked.indexOf(5) !== -1"
								:fixed="shouldFixDimensionColumn">
									<template slot-scope="scope">
										<div v-if="props.row.type">
											<div>{{getAdTypeRenderText(props.row)}}</div>
										</div>
										<div v-else>-</div>
									</template>
								</el-table-column>
								<el-table-column prop="" min-width="180" label="广告源" v-if="tHeaderQueryChecked.indexOf(6) !== -1"
								:fixed="shouldFixDimensionColumn">
									<template slot-scope="scope">
										<div v-if="scope.row.platAdsId">
											<div>{{scope.row.platAdsName}}</div>
											<div style="color: #999999;">{{scope.row.platAdsId}}</div>
										</div>
										<div v-else>-</div>
									</template>
								</el-table-column>
								<template v-for="(columnObj,index) in tHeadCheckedList">
									<template v-if="columnObj.prop == 'pv'||columnObj.prop == 'uv'">
										<el-table-column v-if="!hasChecked" :prop="columnObj.prop" :label="columnObj.label" align="right"
											:width="columnObj.width" :fixed="columnObj.fixed" :sortable="columnObj.sortable?'custom':false"
											:key="index" :min-width="columnObj.minWidth">
										</el-table-column>
									</template>
									<template v-else-if="columnObj.prop == 'avgReqNum'">
										<el-table-column :prop="columnObj.prop" :label="columnObj.label" align="right"
											:width="columnObj.width" :fixed="columnObj.fixed" :sortable="columnObj.sortable?'custom':false"
											:key="index" :min-width="columnObj.minWidth">
											 - 
										</el-table-column>
									</template>
									<template v-else-if="columnObj.prop == 'deu'">
										<el-table-column v-if="hasChecked" prop="deu" :label="columnObj.label" align="right"
											:width="columnObj.width" :fixed="columnObj.fixed" :sortable="columnObj.sortable?'custom':false"
											:key="index" :min-width="columnObj.minWidth">
										</el-table-column>
										<el-table-column v-else prop="appDeu" :label="columnObj.label" align="right"
											:width="columnObj.width" :fixed="columnObj.fixed" :sortable="columnObj.sortable?'custom':false"
											:key="index" :min-width="columnObj.minWidth">
										</el-table-column>
									</template>
									<template v-else-if="columnObj.prop == 'arpU'">
										<el-table-column v-if="!hasChecked" :prop="columnObj.prop" :label="columnObj.label" align="right"
											:width="columnObj.width" :fixed="columnObj.fixed" :sortable="columnObj.sortable?'custom':false"
											:key="index" :min-width="columnObj.minWidth">
										</el-table-column>
										<el-table-column v-else :prop="columnObj.prop" :label="columnObj.label" align="right"
											:width="columnObj.width" :fixed="columnObj.fixed" :sortable="columnObj.sortable?'custom':false"
											:key="index" :min-width="columnObj.minWidth">
											-
										</el-table-column>
									</template>
									<template v-else>
										<el-table-column v-if="columnObj.prop == 'reqNum'" :prop="columnObj.prop" label="广告请求量"
											align="right" :width="columnObj.width" :fixed="columnObj.fixed"
											:sortable="columnObj.sortable?'custom':false" :key="index" :min-width="columnObj.minWidth">
										</el-table-column>
										<el-table-column v-else-if="columnObj.prop == 'succNum'" :prop="columnObj.prop" label="广告返回量"
											align="right" :width="columnObj.width" :fixed="columnObj.fixed"
											:sortable="columnObj.sortable?'custom':false" :key="index" :min-width="columnObj.minWidth">
										</el-table-column>
										<el-table-column v-else-if="columnObj.prop == 'succReqRate'" :prop="columnObj.prop" label="广告填充率"
											align="right" :width="columnObj.width" :fixed="columnObj.fixed"
											:sortable="columnObj.sortable?'custom':false" :key="index" :min-width="columnObj.minWidth">
										</el-table-column>
										<el-table-column v-else-if="columnObj.prop == 'showNum'" :prop="columnObj.prop" label="广告展示量"
											align="right" :width="columnObj.width" :fixed="columnObj.fixed"
											:sortable="columnObj.sortable?'custom':false" :key="index" :min-width="columnObj.minWidth">
										</el-table-column>
										<el-table-column v-else-if="columnObj.prop == 'succShowRate'" :prop="columnObj.prop" label="广告展示率"
											align="right" :width="columnObj.width" :fixed="columnObj.fixed"
											:sortable="columnObj.sortable?'custom':false" :key="index" :min-width="columnObj.minWidth">
										</el-table-column>
										<el-table-column v-else-if="columnObj.prop == 'clickNum'" :prop="columnObj.prop" label="广告点击量(未去重)"
											align="right" :width="columnObj.width" :fixed="columnObj.fixed"
											:sortable="columnObj.sortable?'custom':false" :key="index" :min-width="columnObj.minWidth">
										</el-table-column>
										<el-table-column v-else-if="columnObj.prop == 'clickRate'" :prop="columnObj.prop" label="广告点击率(未去重)"
											align="right" :width="columnObj.width" :fixed="columnObj.fixed"
											:sortable="columnObj.sortable?'custom':false" :key="index" :min-width="columnObj.minWidth">
										</el-table-column>
										<el-table-column v-else-if="columnObj.prop == 'uniqueClickNum'" :prop="columnObj.prop"
											label="广告点击量(去重)" align="right" :width="columnObj.width" :fixed="columnObj.fixed"
											:sortable="columnObj.sortable?'custom':false" :key="index" :min-width="columnObj.minWidth">
										</el-table-column>
										<el-table-column v-else-if="columnObj.prop == 'uniqueClickRate'" :prop="columnObj.prop"
											label="广告点击率(去重)" align="right" :width="columnObj.width" :fixed="columnObj.fixed"
											:sortable="columnObj.sortable?'custom':false" :key="index" :min-width="columnObj.minWidth">
										</el-table-column>
										<el-table-column v-else-if="columnObj.prop == 'deductClickNum'" :prop="columnObj.prop"
											label="广告点击量(扣量后)" align="right" :width="columnObj.width" :fixed="columnObj.fixed"
											:sortable="columnObj.sortable?'custom':false" :key="index" :min-width="columnObj.minWidth">
										</el-table-column>
										<el-table-column v-else-if="columnObj.prop == 'deductClickRate'" :prop="columnObj.prop"
											label="广告点击率(扣量后)" align="right" :width="columnObj.width" :fixed="columnObj.fixed"
											:sortable="columnObj.sortable?'custom':false" :key="index" :min-width="columnObj.minWidth">
										</el-table-column>
										<el-table-column v-else-if="columnObj.prop == 'bidWinNum'" :prop="columnObj.prop"
											label="广告竞胜量" align="right" :width="columnObj.width" :fixed="columnObj.fixed"
											:sortable="columnObj.sortable?'custom':false" :key="index" :min-width="columnObj.minWidth">
										</el-table-column>
										<el-table-column v-else-if="columnObj.label == '耗时时长/ms'" prop="adReqAvgDurationMs"
											:label="columnObj.label" align="right" :width="columnObj.width" :fixed="columnObj.fixed"
											:sortable="columnObj.sortable?'custom':false" :key="index" :min-width="columnObj.minWidth">
										</el-table-column>
										<el-table-column v-else :prop="columnObj.prop" :label="columnObj.label" align="right"
											:width="columnObj.width" :fixed="columnObj.fixed" :sortable="columnObj.sortable?'custom':false"
											:key="index" :min-width="columnObj.minWidth">
											<!-- <template v-slot="scope" v-if="columnObj.temp">
												<slot :name="columnObj.prop" :scope="scope" v-if="['reqGapRate', 'reqSuccGapRate', 'showGapRate',
												'clickGapRate','ecpmGapRate','incomeGapRate'].includes(columnObj.prop)">
													<div v-if="scope.row[columnObj.prop] !== null">{{scope.row[columnObj.prop]}}%</div>
													<div v-else>-</div>
												</slot>
											</template> -->
										</el-table-column>
									</template>
								</template>
								<el-table-column prop="" label="操作" align="center" :fixed="isMobileOrTablet ? false : 'right'" width="80">
									<template slot-scope="scope">
										<el-button type="text" @click="timeSharDrawOpen(scope.row,2,props.row)"
											v-if="tHeaderQueryChecked.indexOf(1) !== -1" v-hasPermi="['dataReport:mediaData:timeshare']">分时</el-button>
									</template>
								</el-table-column>
							</el-table>
						</template>
					</el-table-column>
					<el-table-column prop="recordTime" label="日期" min-width="100"
						v-if="tHeaderQueryChecked.indexOf(1) !== -1" sortable="custom" :fixed="shouldFixDimensionColumn"></el-table-column>
					<el-table-column prop="companyName" label="媒体公司" min-width="160"
					 v-if="tHeaderQueryChecked.indexOf(2) !== -1" :fixed="shouldFixDimensionColumn"></el-table-column>
					<el-table-column prop="os" label="操作系统" min-width="90" :fixed="shouldFixDimensionColumn"
						v-if="tHeaderQueryChecked.indexOf(3) !== -1"></el-table-column>
					<el-table-column prop="mediaAppId" label="应用" min-width="160" :fixed="shouldFixDimensionColumn"
						v-if="tHeaderQueryChecked.indexOf(4) !== -1">
						<template slot-scope="scope">
							<div v-if="scope.row.mediaAppId">
								<div>{{scope.row.mediaAppName}}</div>
								<div style="color: #4F7AFD;">{{scope.row.mediaAppId}}</div>
							</div>
							<div v-else>-</div>
						</template>
					</el-table-column>
					<el-table-column prop="type" label="广告位类型" min-width="130" :fixed="shouldFixDimensionColumn"
						v-if="tHeaderQueryChecked.indexOf(5) !== -1">
						<template slot-scope="scope">
							<span>{{getAdTypeRenderText(scope.row)}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="mediaAdName" label="聚合广告位" min-width="180" :fixed="shouldFixDimensionColumn"
						v-if="tHeaderQueryChecked.indexOf(6) !== -1">
						<template slot-scope="scope">
							<div v-if="scope.row.mediaAdId">
								<div>{{scope.row.mediaAdName}}</div>
								<div style="color: #4F7AFD;">{{scope.row.mediaAdId}}</div>
							</div>
							<div v-else>-</div>
						</template>
					</el-table-column>
					<template v-for="(columnObj,index) in tHeadCheckedList">
						<template v-if="columnObj.prop == 'pv'||columnObj.prop == 'uv'">
							<el-table-column v-if="!hasChecked" :prop="columnObj.prop" :label="columnObj.label" align="right"
								:width="columnObj.width" :fixed="columnObj.fixed" :sortable="columnObj.sortable?'custom':false"
								:key="index" :min-width="columnObj.minWidth">
							</el-table-column>
						</template>
						<template v-else-if="columnObj.prop == 'deu'">
							<el-table-column v-if="hasChecked" prop="deu" :label="columnObj.label" align="right"
								:width="columnObj.width" :fixed="columnObj.fixed" :sortable="columnObj.sortable?'custom':false"
								:key="index" :min-width="columnObj.minWidth">
							</el-table-column>
							<el-table-column v-else prop="appDeu" :label="columnObj.label" align="right"
								:width="columnObj.width" :fixed="columnObj.fixed" :sortable="columnObj.sortable?'custom':false"
								:key="index" :min-width="columnObj.minWidth">
							</el-table-column>
						</template>
						<template v-else-if="columnObj.prop == 'arpU'">
							<el-table-column v-if="!hasChecked" :prop="columnObj.prop" :label="columnObj.label" align="right"
								:width="columnObj.width" :fixed="columnObj.fixed" :sortable="columnObj.sortable?'custom':false"
								:key="index" :min-width="columnObj.minWidth">
							</el-table-column>
							<el-table-column v-else :prop="columnObj.prop" :label="columnObj.label" align="right"
								:width="columnObj.width" :fixed="columnObj.fixed" :sortable="columnObj.sortable?'custom':false"
								:key="index" :min-width="columnObj.minWidth">
											-
							</el-table-column>
						</template>
						<template v-else>
							<el-table-column :prop="columnObj.prop" :label="columnObj.label" align="right" :width="columnObj.width"
								:fixed="columnObj.fixed" :sortable="columnObj.sortable?'custom':false" :key="index" :min-width="columnObj.minWidth">
								<!-- <template v-slot="scope" v-if="columnObj.temp">
									<slot :name="columnObj.prop" :scope="scope" v-if="['reqGapRate', 'reqSuccGapRate', 'showGapRate',
									'clickGapRate','ecpmGapRate','incomeGapRate'].includes(columnObj.prop)">
										<div v-if="scope.row[columnObj.prop] !== null">{{scope.row[columnObj.prop]}}%</div>
										<div v-else>-</div>
									</slot>
								</template> -->
							</el-table-column>
						</template>
					</template>
					<el-table-column prop="" label="操作" align="center" :fixed="isMobileOrTablet ? false : 'right'" width="80">
						<template slot-scope="scope">
							<el-button type="text" @click="timeSharDrawOpen(scope.row,1)"
								v-if="tHeaderQueryChecked.indexOf(1) !== -1&&scope.$index>0"
								v-hasPermi="['dataReport:mediaData:timeshare']">分时</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="paging">
					<el-pagination @size-change="handleSizeChange" background @current-change="handleCurrentChange"
						:current-page="currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="pageSize"
						layout="total, sizes, prev, pager, next, jumper" :total="total">
					</el-pagination>
				</div>
			</div>
		</div>
		<el-drawer @close="closeDrawer" :visible.sync="timeSharDrawShow" size="60%" :wrapperClosable="true"
			:with-header="false">
			<el-card class="box-card">
				<div slot="header" class="cardTitle flex_start">
					<div class="cardTitleTxt">{{drawerForm.mediaAdName}}<span
							v-if="drawerForm.platformName">/{{drawerForm.platformName}}</span>/{{drawerForm.recordTime}}/分时数据</div>
					<el-button type="primary" size="mini" @click="timeSharExport" style="margin-left: 15px;"
					v-hasPermi="['dataReport:mediaData:export']" v-if="timeSharType==1">导出</el-button>
					<i class="el-icon-circle-close" @click="timeSharDrawShow=false" style="margin-left: auto;"></i>
				</div>
				<el-table :max-height="650" :data="tableTimeSharData" class="el_table" @sort-change="sortChangeDrawerFun"
					:header-cell-style="{color:'#333333',background:'#EAEFF5'}"
					:header-cell-class-name="handleHeadAddClassDrawer">
					<el-table-column prop="recordTime" label="时间"></el-table-column>
					<!-- <el-table-column prop="" label="广告位/ID">
						<template slot-scope="scope">
							<div >{{scope.row.mediaAdName}}/{{scope.row.mediaAdId}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="" label="所属应用/ID" width="200">
						<template slot-scope="scope">
							<div >{{scope.row.mediaAppName}}/{{scope.row.mediaAppId}}</div>
						</template>
					</el-table-column> -->
					<el-table-column prop="pv" label="初始化PV" v-if="timeSharType==1&&!hasChecked"></el-table-column>
					<!-- <el-table-column prop="uv" label="初始化UV"></el-table-column> -->
					<el-table-column prop="reqNum" label="请求量"></el-table-column>
					<el-table-column prop="succNum" sortable="custom" label="成功量"></el-table-column>
					<el-table-column prop="succReqRate" label="请求成功率"></el-table-column>
					<el-table-column prop="showNum" sortable="custom" label="展示量"></el-table-column>
					<el-table-column prop="succShowRate" label="展示率"></el-table-column>
					<el-table-column prop="fillRate" label="竞得率"></el-table-column>
					<!-- <el-table-column prop="clickNum" sortable="custom" label="点击量" width="110"></el-table-column> -->
					<el-table-column prop="clickNum" sortable="custom" label="未去重点击数" width="110"></el-table-column>
					<el-table-column prop="uniqueClickNum" label="去重点击数"></el-table-column>
					<el-table-column prop="deductClickNum" label="扣量后点击数" width="110"></el-table-column>
					<el-table-column prop="deductClickRate" label="点击率"></el-table-column>
					<el-table-column prop="bidPriceUnit" label="总收益"></el-table-column>
					<!-- <el-table-column prop="ecpmChannel" label="渠道eCPM"></el-table-column> -->
					<el-table-column prop="winPriceUnit" label="媒体收益"></el-table-column>
					<!-- <el-table-column prop="ecpmMedia" label="媒体eCPM"></el-table-column> -->
					<!-- <el-table-column prop="avgShowNum" label="均展量"></el-table-column> -->
					<el-table-column prop="finishNum" sortable="custom" label="完播量"></el-table-column>
					<el-table-column prop="finishRate" label="完播率"></el-table-column>
				</el-table>
				<!-- <div class="paging">
					<el-pagination @size-change="handleSizeChange" background @current-change="handleCurrentChange" :current-page="currentPage"
						:page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
						:total="total">
					</el-pagination>
				</div> -->
			</el-card>
		</el-drawer>
		<el-dialog title="自定义指标" :visible.sync="tHeadDialogVisible" width="56%">
			<div class="tHeadEditBox space_between">
				<div class="tHeadAllList">
					<el-collapse v-model="activeNames">
						<el-collapse-item :title="item.name" :name="index" v-for="(item,index) in tHeadAllList" :key="index">
							<div class="checkList">
								<el-checkbox :indeterminate="item.isIndeterminate" v-model="item.groupChecked" class="el_check_box"
									@change="handleGroupCheckChange($event,item,index)" style="width: 100%;">全选</el-checkbox>
								<el-checkbox v-for="(items,indexs) in item.list" :key="indexs" size="medium"
									@change="checkChange($event,index,items,indexs)" v-model="items.checked" class="el_check_box">
									{{items.label}}
								</el-checkbox>
							</div>
						</el-collapse-item>
					</el-collapse>
				</div>
				<div class="tHeadCheckShowBox">
					<div class="tHeadCheckShowTitle">已选指标</div>
					<div class="tHeadCheckShowTips">上下拖动可调整排序</div>
					<div class="tHeadCheckShowList" v-show="tHeadCheckShowList.length>0">
						<div class="tHeadCheckedOne flex_start" v-for="(item,index) in tHeadCheckShowList" :key="index"
							@dragstart="handleDragStart($event, item)" @dragover.prevent="handleDragOver($event, item)"
							@dragenter="handleDragEnter($event, item)" @dragend="handleDragEnd($event, item)" :draggable="true">
							<!-- <i class="el-icon-notebook-2"></i> -->
							<img src="../../assets/icon/sort.png" alt="" />
							<div>{{item.label}}</div>
							<i class="el-icon-close" style="margin-left: auto;" @click.stop="deleteTHeadChecked(item,index)"></i>
						</div>
					</div>
					<el-empty description="暂无数据" v-show="tHeadCheckShowList.length<=0"></el-empty>
				</div>
			</div>
			<div class="card-bottom flex_end">
				<el-button @click="closeTHeadDialog" size="medium">取消</el-button>
				<el-button type="primary" @click="confirmTHeadDialog()" size="medium">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				mainHeadTitle: '媒体管理',
				companyDrawerShow: false,
				isDimensionIndeterminate: false,
				dimensionCheckAll: true,
				datePicker: [], // 日期选择
				osOptions: this.$api.osOptions, // OS下拉选择列表
				mediaAppOptions: [], // 媒体APP下拉选择列表
				appSelectForm: {}, // 媒体APP下拉选中值
				appRemoteLoading: false,
				adTypeOptions: this.$api.adsTypeOptions, // 广告类型下拉选择
				networkOptions: [], // 广告网络下拉列表
				accountOptions: [], // 账号名称下拉选择列表
				appPropertyOptions: this.$api.appPropertyOptions, // 应用属性下拉选择列表

				adsSelectForm: {}, //广告位下拉选中数据
				mediaAdsOptions: [], // 广告位下拉选择列表
				adsSelectFormChannel: {}, //渠道广告位下拉选中数据
				channelAdsOptions: [], //渠道广告位下拉列表
				adsRemoteLoading: false,

				queryData: {
					platformNetworkId: '',
					appProperty: ''
				}, // 列表请求筛选项
				tableData: [],
				currentPage: 1,
				pageSize: 10,
				total: 0,
				rulesApi: {
					companyName: [ //公司名称
						{
							required: true,
							message: '必填项，请输入',
							trigger: 'blur'
						},
						{
							min: 1,
							max: 50,
							message: '长度在 1 到 50 个字符',
							trigger: 'blur'
						}
					],
					nickName: [ //公司地址
						{
							required: true,
							message: '请输入公司简称',
							trigger: 'blur'
						},
					],
				},
				tHeaderQueryChecked: [1,2, 3, 4, 5, 6],
				tHeaderQueryData: [{
						value: 'recordTime',
						valueNum: 1,
						label: "日期",
						checked: false
					},
					{
						value: 'companyName',
						valueNum: 2,
						label: "媒体公司",
						checked: false
					},
					{
						value: 'os',
						valueNum: 3,
						label: "操作系统",
						checked: false
					},
					{
						value: 'mediaAppId',
						valueNum: 4,
						label: "应用",
						checked: false
					},
					{
						value: 'type',
						valueNum: 5,
						label: "广告位类型",
						checked: false
					},
					{
						value: 'mediaAdId',
						valueNum: 6,
						label: "聚合广告位",
						checked: false
					},
				],

				expandedRows: [], // 记录展开的行

				// 表格排序数据
				sortField: {},
				orderBys: [],
				sortSecField: {},
				orderSecBys: [],
				sortFieldDrawer: {},
				orderBysDrawer: [],
				companyOptions: [], // 公司下拉选择列表
				timeSharDrawShow: false,
				tableTimeSharData: [], // 分时数据列表
				drawerForm: {},
				timeSharType: 1,


				tHeadDialogVisible: false,
				activeNames: [0, 1, 2],
				tHeadAllList: [{
						name: '统计指标',
						groupChecked: false,
						isIndeterminate: false,
						list: [
							{
								prop: 'channelEstimateProfit',
								label: "总收益(¥)",
								checked: false,
								sortable: true,
								minWidth: '120'
							},
							{
								prop: 'estimateProfit',
								label: "媒体收益(¥)",
								checked: false,
								sortable: true,
								minWidth: '120'
							},
							{
								prop: 'divideEstimateProfit',
								label: "分成收益(¥)",
								checked: false,
								sortable: true,
								minWidth: '120'
							},
							{
								prop: 'reqNum',
								label: "流量请求量",
								checked: false,
								sortable: true,
								minWidth: '120',
							},
							{
								prop: 'avgReqNum',
								label: "人均请求量",
								checked: false,
								sortable: false,
								minWidth: '120',
							},
							{
								prop: 'succNum',
								label: "流量返回量",
								checked: false,
								sortable: true,
								minWidth: '120',
							},
							{
								prop: 'succReqRate',
								label: "流量填充率",
								checked: false,
								sortable: true,
								minWidth: '120',
							},
							{
								prop: 'showNum',
								label: "流量展示量",
								checked: false,
								sortable: true,
								minWidth: '120',
							},
							{
								prop: 'succShowRate',
								label: "流量展示率",
								checked: false,
								sortable: true,
								minWidth: '120',
							},
							{
								prop: 'clickNum',
								label: "流量点击量(未去重)",
								checked: false,
								sortable: true,
								minWidth: '150',
							},
							{
								prop: 'uniqueClickNum',
								label: "流量点击量(去重)",
								checked: false,
								sortable: true,
								minWidth: '140'
							},
							{
								prop: 'deductClickNum',
								label: "流量点击量(扣量后)",
								checked: false,
								sortable: true,
								minWidth: '150',
							},
							{
								prop: 'clickRate',
								label: "流量点击率(未去重)",
								checked: false,
								sortable: true,
								minWidth: '150',
							},
							{
								prop: 'uniqueClickRate',
								label: "流量点击率(去重)",
								checked: false,
								sortable: true,
								minWidth: '150',
							},
							{
								prop: 'deductClickRate',
								label: "流量点击率(扣量后)",
								checked: false,
								sortable: true,
								minWidth: '150',
							},
							{
								prop: 'bidWinNum',
								label: "流量竞胜量",
								checked: false,
								sortable: false,
								minWidth: '120',
							},
							{
								prop: 'otherWinNum',
								label: "三方平台竞胜量",
								checked: false,
								sortable: false,
								minWidth: '120',
							},
							{
								prop: 'otherFailNum',
								label: "三方平台竞败量",
								checked: false,
								sortable: false,
								minWidth: '120',
							},
							{
								prop: 'trafficReqAvgDurationMs',
								label: "耗时时长/ms",
								checked: false,
								sortable: false,
								minWidth: '120',
							},
							{
								prop: 'channelEcpm',
								label: "总收益eCPM(¥)",
								checked: false,
								sortable: true,
								minWidth: '140',
							},
							{
								prop: 'ecpm',
								label: "媒体收益eCPM(¥)",
								checked: false,
								sortable: true,
								minWidth: '140'
							},
							{
								prop: 'pv',
								label: "PV",
								checked: false,
								sortable: false,
								minWidth: '120'
							},
							{
								prop: 'uv',
								label: "UV",
								checked: false,
								sortable: false,
								minWidth: '120'
							},
							{
								prop: 'deu',
								label: "DEU",
								checked: false,
								sortable: false,
								minWidth: '120',
							},
							{
								prop: 'arpU',
								label: "ARPU",
								checked: false,
								sortable: false,
								minWidth: '120',
							},
							{
								prop: 'fillRate',
								label: "竞得率",
								checked: false,
								sortable: true,
								minWidth: '120'
							},
							{
								prop: 'avgShowNum',
								label: "均展量",
								checked: false,
								sortable: true,
								minWidth: '120'
							},
							{
								prop: 'finishNum',
								label: "完播量",
								checked: false,
								sortable: true,
								minWidth: '120'
							},
							{
								prop: 'finishRate',
								label: "完播率",
								checked: false,
								sortable: true,
								minWidth: '120'
							},
							{
								prop: 'networkClickNum',
								label: "聚合监听点击量",
								checked: false,
								sortable: true,
								minWidth: '140',
							},
							{
								prop: 'networkClickRate',
								label: "聚合监听点击率",
								checked: false,
								sortable: true,
								minWidth: '140',
							},
							{
								prop: 'networkUniqueClickNum',
								label: "聚合监听点击量(去重)",
								checked: false,
								sortable: true,
								minWidth: '160',
							},
							{
								prop: 'networkUniqueClickRate',
								label: "聚合监听点击率(去重)",
								checked: false,
								sortable: true,
								minWidth: '160',
							},
						]
					},
					{
						name: 'API指标',
						groupChecked: false,
						isIndeterminate: false,
						list: [{
								prop: 'apiIncome',
								label: "API收益",
								checked: false,
								sortable: true,
								minWidth: '140'
							},
							{
								prop: 'apiReqNum',
								label: "API请求量",
								checked: false,
								sortable: true,
								minWidth: '140'
							},
							{
								prop: 'apiSuccNum',
								label: "API返回量",
								checked: false,
								sortable: true,
								minWidth: '140'
							},
							{
								prop: 'apiSuccRate',
								label: "API填充率",
								checked: false,
								sortable: true,
								minWidth: '140'
							},
							{
								prop: 'apiShowNum',
								label: "API展示量",
								checked: false,
								sortable: true,
								width: '120',
							},
							{
								prop: 'apiUniqueClickNum',
								label: "API点击量(去重)",
								checked: false,
								sortable: true,
								width: '140'
							},
							{
								prop: 'apiDeductClickNum',
								label: "API点击量(扣量后)",
								checked: false,
								sortable: true,
								width: '140',
							},
							{
								prop: 'apiUniqueClickRate',
								label: "API点击率(去重)",
								checked: false,
								sortable: true,
								width: '150',
							},
							{
								prop: 'apiDeductClickRate',
								label: "API点击率(扣量后)",
								checked: false,
								sortable: true,
								width: '150',
							},
							{
								prop: 'apiEcpm',
								label: "API eCPM(￥)",
								checked: false,
								sortable: true,
								width: '120'
							}
						]
					},
					{
						name: '数据GAP',
						groupChecked: false,
						isIndeterminate: false,
						list: [{
								prop: 'reqGapRate',
								label: "请求GAP率",
								checked: false,
								sortable: true,
								width: '120',
								temp: true
							},
							{
								prop: 'reqSuccGapRate',
								label: "返回GAP率",
								checked: false,
								sortable: true,
								width: '120',
								temp: true
							},
							{
								prop: 'showGapRate',
								label: "展示GAP率",
								checked: false,
								sortable: true,
								width: '120',
								temp: true
							},
							{
								prop: 'clickGapRate',
								label: "点击GAP率",
								checked: false,
								sortable: true,
								width: '120',
								temp: true
							},
							{
								prop: 'ecpmGapRate',
								label: "eCPM GAP率",
								checked: false,
								sortable: true,
								width: '120',
								temp: true
							},
							{
								prop: 'incomeGapRate',
								label: "收益GAP率",
								checked: false,
								sortable: true,
								width: '120',
								temp: true
							}
						]
					}
				],
				tHeadCheckShowList: [], // 表头选中临时展示列表
				tHeadCheckedList: [], //最终选中的表头展示数组
				// 默认展示的表头
				tHeadNormalCheckedList: [{
						prop: 'estimateProfit',
						label: "媒体收益(¥)",
						checked: true,
						sortable: true,
						minWidth: '120',
					},
					{
						prop: 'reqNum',
						label: "流量请求量",
						checked: true,
						sortable: true,
						minWidth: '120',
					},
					{
						prop: 'showNum',
						label: "流量展示量",
						checked: true,
						sortable: true,
						minWidth: '120',
					},
					{
						prop: 'deductClickNum',
						label: "流量点击量(扣量后)",
						checked: true,
						sortable: true,
						minWidth: '150',
					},
					{
						prop: 'ecpm',
						label: "eCPM(￥)",
						checked: true,
						sortable: true,
						minWidth: '120'
					},
					{
						prop: 'apiIncome',
						label: "API收益",
						checked: true,
						sortable: true,
						minWidth: '140'
					},
					{
						prop: 'apiReqNum',
						label: "API请求量",
						checked: true,
						sortable: true,
						minWidth: '140'
					},
					{
						prop: 'apiShowNum',
						label: "API展示量",
						checked: true,
						sortable: true,
						minWidth: '120',
					},
					{
						prop: 'apiDeductClickNum',
						label: "API点击量(扣量后)",
						checked: true,
						sortable: true,
						minWidth: '140',
					},
					{
						prop: 'apiEcpm',
						label: "API eCPM(￥)",
						checked: false,
						sortable: true,
						minWidth: '120'
					},
					{
						prop: 'incomeGapRate',
						label: "收益GAP率",
						checked: true,
						sortable: true,
						minWidth: '120',
						temp: true
					}
				],
				dragging: null,
				// 是否为媒介角色：sdk-roleType 包含且仅包含 MEDIUM 时为 true
				isMediumRole: false,
				// 媒介角色自定义指标白名单
				mediumTHeadProps: ['estimateProfit', 'reqNum', 'succNum', 'succReqRate', 'showNum', 'succShowRate', 'deductClickNum', 'deductClickRate', 'ecpm', 'pv', 'uv', 'deu', 'fillRate'],
				// 自定义指标全集备份，用于账号角色切换后恢复完整指标
				tHeadAllSourceList: [],
				isMobileOrTablet: false, // 是否为平板或手机端，移动端只保留展开列固定
				tableFixedMediaQuery: null, // 表格固定列的媒体查询对象
			}
		},
		computed: {
			// 桌面端维度少于 5 个时固定维度列，平板和手机端始终不固定
			shouldFixDimensionColumn() {
				return !this.isMobileOrTablet && this.tHeaderQueryChecked.length < 5
			},
			hasChecked() {
				return this.tHeaderQueryChecked.some(item => [5, 6].includes(item));
			},
			// 判断表头是否包pv、uv
			hasRequiredPropsPUV() {
				const requiredProps = ['pv', 'uv'];
				return requiredProps.some(prop =>
					this.tHeadCheckedList.some(item => item.prop === prop)
				);
			},
			hasRequiredProps() {
				const requiredProps = ['apiIncome', 'apiReqNum', 'apiSuccNum', 'apiSuccRate', 'apiShowNum', 'apiUniqueClickNum',
					'apiDeductClickNum', 'apiUniqueClickRate', 'apiDeductClickRate', 'apiEcpm'
				];
				return requiredProps.some(prop =>
					this.tHeadCheckedList.some(item => item.prop === prop)
				);
			},
		},
		activated() {
			this.syncLoginRole();
			this.applyMediumTHeadLimit();
			this.$nextTick(() => {
				if (this.$route.query.os) {
					this.queryData['os'] = this.$route.query.os
				}
				if (this.$route.query.appId) {
					this.queryData['appId'] = this.$route.query.appId
				}
				this.getTableData();
			})
		},
		mounted() {
			this.initTableFixedMediaQuery();
			this.tHeadAllSourceList = JSON.parse(JSON.stringify(this.tHeadAllList));
			this.syncLoginRole();
			let tHeadCache = this.getTHeadCache();
			if (tHeadCache) {
				this.tHeadCheckedList = tHeadCache
			} else {
				// this.tHeadAllList.forEach((category, categoryIndex) => {
				// 	const foundItem = category.list.forEach(items => {
				// 		this.$set(items, 'checked', true);
				// 		this.tHeadNormalCheckedList.push(items);
				// 	});
				// });
				this.tHeadCheckedList = JSON.parse(JSON.stringify(this.tHeadNormalCheckedList))
			}
			this.applyMediumTHeadLimit();
			this.dateInit();
			// this.getOSOption();
			this.getCompanyOption();
			this.getMediaAppOption();
			// this.getADTypeOption();
			this.getNetworkOtions();
			this.getAccountOptions();
			this.getMediaAdsOption(2, null); // 获取聚合广告位下拉列表
			this.getChannelAdsOption(2, null);
		},
		beforeDestroy() {
			// 组件销毁时移除媒体查询监听，避免重复绑定
			if (!this.tableFixedMediaQuery) return
			if (this.tableFixedMediaQuery.removeEventListener) {
				this.tableFixedMediaQuery.removeEventListener('change', this.updateTableFixedState)
			} else {
				this.tableFixedMediaQuery.removeListener(this.updateTableFixedState)
			}
		},
		methods: {
			// 初始化表格固定列媒体查询，并监听平板、手机端视口变化
			initTableFixedMediaQuery() {
				this.tableFixedMediaQuery = window.matchMedia('(max-width: 1024px)')
				this.updateTableFixedState(this.tableFixedMediaQuery)
				if (this.tableFixedMediaQuery.addEventListener) {
					this.tableFixedMediaQuery.addEventListener('change', this.updateTableFixedState)
				} else {
					this.tableFixedMediaQuery.addListener(this.updateTableFixedState)
				}
			},
			// 更新设备状态，并在固定列变化后重新计算表格布局
			updateTableFixedState(mediaQueryEvent) {
				this.isMobileOrTablet = mediaQueryEvent.matches
				this.$nextTick(() => {
					if (this.$refs.tables) this.$refs.tables.doLayout()
				})
			},
			// 拼接广告位类型与渲染类型展示文案
			getAdTypeRenderText(row) {
				if(!row.type){
					return '-'
				}
				if(row.isSelfRender === 1||row.isSelfRender === '1'){
					return `${row.type}（自渲染）`
				}
				if(row.isSelfRender === 0||row.isSelfRender === '0'){
					return `${row.type}（模版渲染）`
				}
				return row.type
			},
			// 同步登录角色，确保账号切换后 keep-alive 页面里的媒介判断及时刷新
			syncLoginRole() {
				let roleType = [];
				let roleTypeCache = sessionStorage.getItem('sdk-roleType');
				if (roleTypeCache) {
					try {
						roleType = JSON.parse(roleTypeCache);
					} catch (e) {
						roleType = roleTypeCache;
					}
				}
				roleType = Array.isArray(roleType) ? roleType : (roleType ? [roleType] : []);
				this.isMediumRole = Array.isArray(roleType) && roleType.length === 1 && roleType.includes('MEDIUM');
			},
			// 媒介角色只保留允许展示的自定义指标；非媒介角色恢复完整指标
			applyMediumTHeadLimit() {
				if (this.tHeadAllSourceList.length > 0) {
					this.tHeadAllList = JSON.parse(JSON.stringify(this.tHeadAllSourceList));
				}
				if (!this.isMediumRole) return;
				this.tHeadAllList = this.tHeadAllList.map(item => {
					return {
						...item,
						list: this.filterMediumTHeadList(item.list)
					}
				}).filter(item => item.list.length > 0);
				this.tHeadCheckedList = this.filterMediumTHeadList(this.tHeadCheckedList);
				this.tHeadCheckShowList = this.filterMediumTHeadList(this.tHeadCheckShowList);
				if (this.tHeadCheckedList.length > 0 || localStorage.getItem(this.getTHeadStorageKey())) {
					localStorage.setItem(this.getTHeadStorageKey(), JSON.stringify(this.tHeadCheckedList));
				}
			},
			// 根据媒介角色指标白名单过滤指标列表
			filterMediumTHeadList(list) {
				return (list || []).filter(item => this.mediumTHeadProps.includes(item.prop)).map(item => {
					let tHeadOption = this.getTHeadOption(item.prop);
					return {
						...(tHeadOption || item),
						checked: item.checked
					}
				});
			},
			// 按 prop 获取指标全集里的标准配置，避免旧缓存指标名称不一致
			getTHeadOption(prop) {
				let tHeadOption = null;
				let tHeadAllList = this.tHeadAllSourceList.length > 0 ? this.tHeadAllSourceList : this.tHeadAllList;
				tHeadAllList.some(category => {
					tHeadOption = category.list.find(item => item.prop === prop);
					return !!tHeadOption;
				});
				return tHeadOption;
			},
			// 自定义指标缓存 key：媒介角色使用独立 key，避免影响其他角色缓存
			getTHeadStorageKey() {
				return this.isMediumRole ? 'sdk-mediaDataTHead-MEDIUM' : 'sdk-mediaDataTHead';
			},
			// 获取自定义指标缓存；媒介首次进入时可读取旧公共缓存做过滤，但不会改写公共缓存
			getTHeadCache() {
				let cache = localStorage.getItem(this.getTHeadStorageKey());
				if (cache) {
					let cacheList = JSON.parse(cache);
					if (cacheList && cacheList.length > 0) return cacheList;
				}
				if (this.isMediumRole) {
					let commonCache = localStorage.getItem('sdk-mediaDataTHead');
					return commonCache ? JSON.parse(commonCache) : null;
				}
				return null;
			},
			// 日期选择器初始化
			dateInit() {
				this.datePicker = []
				let currentDate = new Date();
				let year = currentDate.getFullYear();
				let month = String(currentDate.getMonth() + 1).padStart(2, '0');
				let day = String(currentDate.getDate()).padStart(2, '0');
				let formattedDate = `${year}-${month}-${day}`;
				this.datePicker.push(formattedDate);
				this.datePicker.push(formattedDate);
			},
			// 获取配置后的广告网络下拉选择列表
			async getNetworkOtions() {
				let res = await this.$http.get(this.$api.mediaAd.networkOptionDistinct);
				this.networkOptions = res.data
			},
			// 获取OS下拉列表
			async getOSOption() {
				let res = await this.$http.get(this.$api.common.osOption);
				this.osOptions = res.data
			},
			// 获取公司下拉列表
			async getCompanyOption() {
				let res = await this.$http.get(this.$api.common.companyOption);
				this.companyOptions = res.data
			},
			// 公司下拉列表选择
			companySelectChange(){
				this.mediaAppOptions = []
				this.getMediaAppOption();
			},
			// 获取媒体APP下拉列表
			async getMediaAppOption(query = null) {
				let data = {
					mediaCompany: this.queryData.mediaCompany,
					appId: query,
				}
				let res = await this.$http.get(this.$api.common.mediaAppOption,data);
				this.appRemoteLoading = false
				this.mediaAppOptions = res.data
			},
			// 获取广告类型下拉列表
			async getADTypeOption() {
				let res = await this.$http.get(this.$api.common.adTypeOption);
				this.adTypeOptions = res.data
			},
			networkOptionsChange(e){
				this.accountOptions = []
				this.queryData.platformNetworkId = ''
				if(e){
					this.getAccountOptions(e);
				}else{
					this.getAccountOptions();
				}
			},
			// 获取账号名称下拉列表
			async getAccountOptions(platformId){
				let data = {platformId: platformId}
				let res = await this.$http.get(this.$api.mediaAd.networkAccountOption,data);
				this.accountOptions = res.data
			},
			async getTableData() {
				let data = {
					pageNum: this.currentPage,
					pageSize: this.pageSize,
					startToday: '',
					endToday: '',
				}
				if (this.datePicker && this.datePicker.length > 0) {
					data.startToday = this.datePicker[0];
					data.endToday = this.datePicker[1];
				}
				data = {
					...data,
					...this.queryData
				}
				if (this.adsSelectForm.value) {
					data['adsId'] = this.adsSelectForm.value
				}
				if(this.appSelectForm.value){
					data['appId'] = this.appSelectForm.value
				}
				if (this.adsSelectFormChannel.value) {
					data['platformAdsId'] = this.adsSelectFormChannel.value
				}
				if (this.tHeaderQueryChecked.length > 0) {
					data['groupByIdList'] = this.tHeaderQueryChecked;
				}
				let res = await this.$http.post(this.$api.dataManage.showDataList, data);
				this.tableData = res.data.data.list
				for (let i = 0; i < this.tableData.length; i++) {
					this.tableData[i]['tabList'] = []
				}
				this.total = res.data.data.totalRecord
				if (res.data.data.list && res.data.data.list.length > 0) {
					let obj = {
						recordTime: '合计',
						companyName: '-',
						mediaAppId: '',
						type: '-',
						os: '-',
						mediaAdId: '',
						channelEstimateProfit: res.data.channelEstimateProfit !== null ? res.data.channelEstimateProfit : '-',
						divideEstimateProfit: res.data.divideEstimateProfit !== null ? res.data.divideEstimateProfit : '-',
						channelEcpm: res.data.channelEcpm !== null ? res.data.channelEcpm : '-',
						estimateProfit: res.data.estimateProfit !== null ? res.data.estimateProfit : '-',
						reqNum: res.data.reqNum !== null ? res.data.reqNum : '-',
						succNum: res.data.succNum !== null ? res.data.succNum : '-',
						succReqRate: res.data.succReqRate !== null ? res.data.succReqRate : '-',
						showNum: res.data.showNum !== null ? res.data.showNum : '-',
						succShowRate: res.data.succShowRate !== null ? res.data.succShowRate : '-',
						clickNum: res.data.clickNum !== null ? res.data.clickNum : '-',
						uniqueClickNum: res.data.uniqueClickNum !== null ? res.data.uniqueClickNum : '-',
						deductClickNum: res.data.deductClickNum !== null ? res.data.deductClickNum : '-',
						clickRate: res.data.clickRate !== null ? res.data.clickRate : '-',
						uniqueClickRate: res.data.uniqueClickRate !== null ? res.data.uniqueClickRate : '-',
						deductClickRate: res.data.deductClickRate !== null ? res.data.deductClickRate : '-',
						ecpm: res.data.ecpm !== null ? res.data.ecpm : '-',
						pv: res.data.pv !== null ? res.data.pv : '-',
						uv: res.data.uv !== null ? res.data.uv : '-',
						deu: res.data.deu !== null ? res.data.deu : '-',
						appDeu: res.data.appDeu !== null ? res.data.appDeu : '-',
						arpU: res.data.arpU !== null ? res.data.arpU : '-',
						fillRate: res.data.fillRate !== null ? res.data.fillRate : '-',
						avgShowNum: res.data.avgShowNum !== null ? res.data.avgShowNum : '-',
						finishNum: res.data.finishNum !== null ? res.data.finishNum : '-',
						finishRate: res.data.finishRate !== null ? res.data.finishRate : '-',
						apiIncome: res.data.apiIncome !== null ? res.data.apiIncome : '-',
						apiReqNum: res.data.apiReqNum !== null ? res.data.apiReqNum : '-',
						apiSuccNum: res.data.apiSuccNum !== null ? res.data.apiSuccNum : '-',
						apiSuccRate: res.data.apiSuccRate !== null ? res.data.apiSuccRate : '-',
						apiShowNum: res.data.apiShowNum !== null ? res.data.apiShowNum : '-',
						apiUniqueClickNum: res.data.apiUniqueClickNum !== null ? res.data.apiUniqueClickNum : '-',
						apiDeductClickNum: res.data.apiDeductClickNum !== null ? res.data.apiDeductClickNum : '-',
						apiUniqueClickRate: res.data.apiUniqueClickRate !== null ? res.data.apiUniqueClickRate : '-',
						apiDeductClickRate: res.data.apiDeductClickRate !== null ? res.data.apiDeductClickRate : '-',
						apiEcpm: res.data.apiEcpm !== null ? res.data.apiEcpm : '-',
						reqGapRate: res.data.reqGapRate !== null ? res.data.reqGapRate : '-',
						reqSuccGapRate: res.data.reqSuccGapRate !== null ? res.data.reqSuccGapRate : '-',
						showGapRate: res.data.showGapRate !== null ? res.data.showGapRate : '-',
						clickGapRate: res.data.clickGapRate !== null ? res.data.clickGapRate : '-',
						ecpmGapRate: res.data.ecpmGapRate !== null ? res.data.ecpmGapRate : '-',
						incomeGapRate: res.data.incomeGapRate !== null ? res.data.incomeGapRate : '-',
						networkClickNum: res.data.networkClickNum !== null ? res.data.networkClickNum : '-',
						networkClickRate: res.data.networkClickRate !== null ? res.data.networkClickRate : '-',
						networkUniqueClickNum: res.data.networkUniqueClickNum !== null ? res.data.networkUniqueClickNum : '-',
						networkUniqueClickRate: res.data.networkUniqueClickRate !== null ? res.data.networkUniqueClickRate : '-',
						avgReqNum: res.data.avgReqNum !== null ? res.data.avgReqNum : '-',
						trafficReqAvgDurationMs: res.data.trafficReqAvgDurationMs !== null ? res.data.trafficReqAvgDurationMs : '-',
						bidWinNum: res.data.bidWinNum !== null ? res.data.bidWinNum : '-',
						otherWinNum: res.data.otherWinNum !== null ? res.data.otherWinNum : '-',
						otherFailNum: res.data.otherFailNum !== null ? res.data.otherFailNum : '-',
					}
					this.tableData.unshift(obj)
				}
			},
			async getMediaTimeShar(row = []) {
				let data = {
					startToday: this.drawerForm.recordTime,
					adsId: this.drawerForm.mediaAdId,
					appId: this.drawerForm.mediaAppId,
					mediaCompany: this.drawerForm.companyName,
					os: this.drawerForm.os,
					type: this.drawerForm.typeValue,
					adOrderByReqs: row
				}
				if (this.tHeaderQueryChecked.length > 0) {
					data['groupByIdList'] = this.tHeaderQueryChecked;
				}
				let res = await this.$http.post(this.$api.dataManage.mediaTimeShar, data);
				this.tableTimeSharData = res.data
			},
			async getMediaTimeSharSec(row = []) {
				let data = {
					recordTime: this.drawerForm.recordTime,
					platAdsId: this.drawerForm.platAdsId,
					platAppId: this.drawerForm.platformAppId,
					companyName: this.drawerForm.companyName,
					platformNetworkId: this.drawerForm.platformNetworkId,
					os: this.drawerForm.os,
					type: this.drawerForm.typeValue,
					adOrderByReqs: row
				}
				if (this.tHeaderQueryChecked.length > 0) {
					data['groupByIdList'] = this.tHeaderQueryChecked;
				}
				let res = await this.$http.post(this.$api.dataManage.mediaTimeSharSec, data);
				this.tableTimeSharData = res.data
			},
			// 获取二级表格列表
			async getAppDataSecList(row, index, orderBys = []) {
				// console.log(index)
				let data = {
					adsId: row.mediaAdId,
					recordTime: row.recordTime,
					appId: row.mediaAppId,
					companyName: row.companyName,
					os: row.os,
					type: row.typeValue,
					appProperty: this.queryData.appProperty
				}
				if (this.tHeaderQueryChecked.length > 0) {
					data['groupByIdList'] = this.tHeaderQueryChecked;
				}
				if(orderBys.length > 0){
					data['adOrderByReqs'] = orderBys;
				}
				// if(this.queryData.platformId){
				// 	data['platformId'] = this.queryData.platformId;
				// }
				// if(this.queryData.platformNetworkId){
				// 	data['platformNetworkId'] = this.queryData.platformNetworkId;
				// }
				// if (this.adsSelectFormChannel.value) {
				// 	data['platformAdsId'] = this.adsSelectFormChannel.value
				// }
				let res = await this.$http.post(this.$api.dataManage.appDataSecList, data);
				this.tableData[index].tabList = res.data
				// this.$set(this.tableData[index], 'tabList', res.data)
				// console.log(this.tableData[index].tabList)
				for (let i = 0; i < this.tableData.length; i++) {
					for (let j = 0; j < this.expandedRows.length; j++) {
						if (this.expandedRows[j].mediaAdId == this.tableData[i].mediaAdId && this.expandedRows[j].recordTime ==
							this.tableData[i].recordTime) {
							this.expandedRows.splice(j, 1, this.tableData[i])
						}
					}
				}
				this.$forceUpdate();
			},
			checkBoxQueryChange(e, item, index) {
				this.tHeaderQueryData[index].checked = e
				
				this.dimensionCheckAll = this.tHeaderQueryChecked.length === this.tHeaderQueryData.length
				this.isDimensionIndeterminate = this.tHeaderQueryChecked.length > 0 &&  this.tHeaderQueryChecked.length < this.tHeaderQueryData.length
				this.currentPage = 1
				this.getTableData();
			},
			handleCheckAllChangeDim(val){
				this.tHeaderQueryChecked = []
				if(val){
					this.tHeaderQueryData.forEach((item) => {
						this.tHeaderQueryChecked.push(item.valueNum)
					})
				}
				this.isDimensionIndeterminate = false;
				
				this.currentPage = 1
				this.getTableData();
			},
			appSeleteChange(e) {
				this.appSelectForm = e
				this.mediaAdsOptions = []
				this.adsSelectForm = {}
				this.getMediaAdsOption(2);
			},
			appRemoteMethod(query){
				clearTimeout();
				setTimeout(()=>{
					this.appRemoteLoading = true
					this.getMediaAppOption(query)
				},300)
			},
			adsSeleteChange(e) {
				if (e && e.value) {
					this.adsSelectForm = e
					// 检查是否包含数字 6，如果不包含则添加
					if (!this.tHeaderQueryChecked.includes(6)) {
					  // 使用扩展运算符创建新数组以确保响应式更新
					  this.tHeaderQueryChecked = [...this.tHeaderQueryChecked, 6]
						this.getTableData();
					  // 或者使用 this.$set
					  // this.$set(this, 'tHeaderQueryChecked', [...this.tHeaderQueryChecked, 6])
					}
				}
			},
			adsRemoteMethod(query) {
				clearTimeout();
				setTimeout(() => {
					this.adsRemoteLoading = true
					this.getMediaAdsOption(2, query)
				}, 300)
			},
			// 获取媒体广告位下拉列表
			async getMediaAdsOption(type, query = null) {
				let data = {
					adsName: query,
					appId: this.appSelectForm.value?this.appSelectForm.value:''
				}
				let res = await this.$http.get(this.$api.common.mediaAdsOption, data);
				this.adsRemoteLoading = false
				this.mediaAdsOptions = res.data
			},
			channelAdsSeleteChange(e) {
				if (e && e.value) {
					this.adsSelectFormChannel = e
				}
			},
			channelAdsRemoteMethod(query) {
				clearTimeout();
				setTimeout(() => {
					this.adsRemoteLoading = true
					this.getChannelAdsOption(2, query)
				}, 300)
			},
			// 获取渠道广告位下拉列表
			async getChannelAdsOption(type, query = null) {
				let data = {
					adsId: query
				}
				let res = await this.$http.post(this.$api.common.channelAdsOption, data);
				this.adsRemoteLoading = false
				this.channelAdsOptions = res.data
			},

			// 复制APP名称
			async copyName(txt) {
				try {
					// 使用现代异步 API
					await navigator.clipboard.writeText(txt)
					this.$message.success('复制成功');
				} catch (err) {
					// 某些环境（比如 HTTP 或非安全上下文）不支持 navigator.clipboard
					// 这里可做回退方案：
					this.fallbackCopy(txt)
				}
			},
			fallbackCopy(text) {
				const input = document.createElement('input')
				input.value = text
				document.body.appendChild(input)
				input.select()
				document.execCommand('copy')
				document.body.removeChild(input)
				this.$message.success('复制成功');
			},
			// 阻止默认上传
			uploadSet() {},
			// 导入
			async uploadFun(file, type) {
				// console.log(file)
				// console.log(type)
				// const fileExtension = file.name.split(".").pop().toLowerCase(); // 获取文件后缀名
				// const isTypeOk = this.fileType.includes(fileExtension);
				// if (!isTypeOk) {
				// 	return false; // 阻止文件上传并移除
				// }
				// 上传
				let formdata = new FormData();
				formdata.append("file", file.raw);
				formdata.append("platId", type);
				let res = await this.$http.post(this.$api.dataManage.appImport, formdata);
				if (res.code == 1) {
					this.$message.success('导入成功');
				}
			},
			// 分时导出
			async timeSharExport(){
				let data = {
					startToday: this.drawerForm.recordTime,
					adsId: this.drawerForm.mediaAdId,
					appId: this.drawerForm.mediaAppId,
					mediaCompany: this.drawerForm.companyName,
					os: this.drawerForm.os,
					type: this.drawerForm.typeValue,
				}
				if (this.tHeaderQueryChecked.length > 0) {
					data['groupByIdList'] = this.tHeaderQueryChecked;
				}
				let res = await this.$http.post(this.$api.dataManage.timeShareExport, data, 1);
				this.$http.downloads(res, `媒体数据_${this.drawerForm.recordTime}_分时数据.xls`);
			},
			// 导出
			async appExport() {
				let data = {
					pageNum: this.currentPage,
					pageSize: this.pageSize,
					startToday: '',
					endToday: '',
				}
				if (this.datePicker && this.datePicker.length > 0) {
					data.startToday = this.datePicker[0];
					data.endToday = this.datePicker[1];
				}
				data = {
					...data,
					...this.queryData
				}
				// 导出与列表使用相同的应用、广告位筛选条件
				if (this.adsSelectForm.value) {
					data['adsId'] = this.adsSelectForm.value
				}
				if (this.appSelectForm.value) {
					data['appId'] = this.appSelectForm.value
				}
				if (this.adsSelectFormChannel.value) {
					data['platformAdsId'] = this.adsSelectFormChannel.value
				}
				if (this.tHeaderQueryChecked.length > 0) {
					data['groupByIdList'] = this.tHeaderQueryChecked;
				}
				let res = await this.$http.post(this.$api.dataManage.appExport, data, 1);
				const time = this.getTimeFun();
				this.$http.downloads(res, `${time}媒体数据.xls`)
			},
			// 下载选择的日期
			getTimeFun() {
				if (!this.datePicker || !this.datePicker.length) {
					return ''
				}
				var startMonth = this.datePicker[0];
				var endMonth = this.datePicker[1];
				// 如果开始时间和结束时间相同，则以开始时间为主
				if (startMonth === endMonth) {
					endMonth = ''
				};
				return startMonth + "-" + endMonth;
			},
			handleSizeChange(val) {
				this.currentPage = 1
				this.pageSize = val
				this.getTableData();
			},
			handleCurrentChange(val) {
				this.currentPage = val
				this.getTableData();
			},
			searchReset() {
				this.currentPage = 1
				this.queryData = {}
				this.adsSelectForm = {}
				this.appSelectForm = {}
				this.adsSelectFormChannel = {}
				this.getTableData();
			},
			confirmQuery() {
				this.currentPage = 1
				this.getTableData();
			},
			editTable(row, index) {
				row['editShow'] = true
				this.$set(this.tableData, index, row)
			},
			editConfirm(row, index) {
				row['editShow'] = false
				this.$set(this.tableData, index, row)
			},
			// 分时弹框展开
			timeSharDrawOpen(row, type, item = null) {
				this.timeSharDrawShow = true
				this.tableTimeSharData = []
				this.sortFieldDrawer = []
				this.orderBysDrawer = []
				console.log(row)
				this.drawerForm = row
				this.timeSharType = type
				if (type == 1) {
					this.getMediaTimeShar()
				} else {
					this.drawerForm['recordTime'] = item.recordTime
					this.drawerForm['mediaAdName'] = item.mediaAdName
					this.drawerForm['typeValue'] = item.typeValue
					this.getMediaTimeSharSec()
				}
			},
			closeDrawer() {
				this.companyDrawerShow = false
			},
			confirmCompany(formName) {
				this.$refs[formName].validate(async (valid) => {
					if (valid) {
						let data = this.companyFormData;
						let res = await this.$http.post(this.$api.companyList, data);
						this.$message.success('编辑成功');
						this.closeDrawer();
						this.getTableData();
					}
				});
			},
			// 动态表头-隐藏时-触发 表头填充
			tHeaderColumnHide() {
				// this.getTableData();
			},
			// 表格展开方法
			handleExpandChange(row, expanded) {
				this.expandedRows = expanded
				const isExpanded = this.expandedRows.some((expandedRow) => expandedRow.mediaAdId === row.mediaAdId && expandedRow
					.recordTime === row.recordTime);
				if (isExpanded) {
					this.tableData.forEach((item, index) => {
						if (row.mediaAdId == item.mediaAdId && row.recordTime == item.recordTime) {
							this.getAppDataSecList(row, index);
						}
					})
				}
				this.orderSecBys = []
				this.sortSecField = {}
			},
			tableRowClassName({
				row
			}) {
				// // 判断当前行是否在 expandedRows 列表中
				// const isExpanded = this.expandedRows.some((expandedRow) => expandedRow.mediaAdId === row.mediaAdId && expandedRow
				// 	.recordTime === row.recordTime);
				// return isExpanded ? 'success-row' : ''; // 如果在展开列表中，则添加类，否则清除类

				const classNames = [];
				// 判断当前行是否在 expandedRows 列表中
				const isExpanded = this.expandedRows.some((expandedRow) => expandedRow.mediaAdId === row.mediaAdId &&
					expandedRow.recordTime === row.recordTime);
				if (isExpanded) {
					classNames.push('success-row');
				}
				// 媒介角色隐藏全部展开按钮；其他角色仅沿用“合计”行的隐藏逻辑
				if (this.isMediumRole || !row.mediaAdId) {
					classNames.push('icon-no');
				}
				return classNames.join(' ');
			},
			// 表头高亮保持
			handleHeadAddClass({
				column
			}) {
				// console.log(column)
				if (this.sortField[column.property]) {
					column.order = this.sortField[column.property]
				}
			},
			// 排序监听
			sortChangeFun({
				column,
				prop,
				order
			}) {
				// 触发的排序和缓存的排序相同时，取消该字段的排序
				if (!order || this.sortField[prop] === order) {
					this.sortField[prop] = null
				} else {
					this.sortField[prop] = order
				}
				this.orderBys = []
				let direction = ''
				for (const i in this.sortField) {
					if (this.sortField[i]) {
						if (this.sortField[i] == 'ascending') {
							direction = 'ASC'
						} else if (this.sortField[i] == 'descending') {
							direction = 'DESC'
						}
						this.orderBys.push({
							"orderField": i,
							"orderType": direction
						})
					}
				}
				this.currentPage = 1
				this.queryData['adOrderByReqs'] = this.orderBys
				this.getTableData() //调用后端查询接口
			},
			sortChangeFunSec({
				column,
				prop,
				order
			},row,index){
				// 触发的排序和缓存的排序相同时，取消该字段的排序
				if (!order || this.sortSecField[prop] === order) {
					this.sortSecField[prop] = null
				} else {
					this.sortSecField[prop] = order
				}
				this.orderSecBys = []
				let direction = ''
				for (const i in this.sortSecField) {
					if (this.sortSecField[i]) {
						if (this.sortSecField[i] == 'ascending') {
							direction = 'ASC'
						} else if (this.sortSecField[i] == 'descending') {
							direction = 'DESC'
						}
						this.orderSecBys.push({
							"orderField": i,
							"orderType": direction
						})
					}
				}
				this.getAppDataSecList(row, index, this.orderSecBys); //调用后端查询接口
			},
			handleHeadAddClassSec({
				column
			}){
				if (this.sortSecField[column.property]) {
					column.order = this.sortSecField[column.property]
				}
			},
			// 表头高亮保持
			handleHeadAddClassDrawer({
				column
			}) {
				// console.log(column)
				if (this.sortFieldDrawer[column.property]) {
					column.order = this.sortFieldDrawer[column.property]
				}
			},
			sortChangeDrawerFun({
				column,
				prop,
				order
			}) {
				// 触发的排序和缓存的排序相同时，取消该字段的排序
				if (!order || this.sortFieldDrawer[prop] === order) {
					this.sortFieldDrawer[prop] = null
				} else {
					this.sortFieldDrawer[prop] = order
				}
				this.orderBysDrawer = []
				let direction = ''
				for (const i in this.sortFieldDrawer) {
					if (this.sortFieldDrawer[i]) {
						if (this.sortFieldDrawer[i] == 'ascending') {
							direction = 'ASC'
						} else if (this.sortFieldDrawer[i] == 'descending') {
							direction = 'DESC'
						}
						this.orderBysDrawer.push({
							"orderField": i,
							"orderType": direction
						})
					}
				}
				// this.currentPage = 1
				// this.queryData['adOrderByReqs'] = this.orderBysDrawer
				if (this.timeSharType == 1) {
					this.getMediaTimeShar(this.orderBysDrawer) //调用后端查询接口
				} else {
					this.getMediaTimeSharSec(this.orderBysDrawer)
				}
			},
			editTheadDialog() {
				this.tHeadDialogVisible = true
				let tHeadCache = this.getTHeadCache();
				if (tHeadCache) {
					this.tHeadCheckShowList = JSON.parse(JSON.stringify(tHeadCache))
					this.tHeadCheckedList = JSON.parse(JSON.stringify(tHeadCache))
				} else {
					this.tHeadCheckedList = JSON.parse(JSON.stringify(this.tHeadNormalCheckedList))
					this.tHeadCheckShowList = JSON.parse(JSON.stringify(this.tHeadNormalCheckedList))
				}
				this.applyMediumTHeadLimit();
				// 初始化分组状态
				this.initGroupStates();
			},
			// 初始化分组状态
			initGroupStates() {
				// 重置所有分组的选中状态
				this.tHeadAllList.forEach((category, categoryIndex) => {
					category.groupChecked = false;
					category.isIndeterminate = false;
				});
				// 遍历选中的列，设置对应的 checked 状态
				this.tHeadCheckShowList.forEach((item) => {
					this.tHeadAllList.forEach((category, categoryIndex) => {
						const foundItem = category.list.find(items => items.label === item.label);
						if (foundItem) {
							this.$set(foundItem, 'checked', true);
						}
					});
				});
				// 更新所有分组的状态
				this.tHeadAllList.forEach((category, categoryIndex) => {
					this.updateGroupState(categoryIndex);
				});
			},
			closeTHeadDialog() {
				this.tHeadDialogVisible = false
			},
			confirmTHeadDialog() {
				if (this.isMediumRole) {
					this.tHeadCheckShowList = this.filterMediumTHeadList(this.tHeadCheckShowList);
				}
				if (this.tHeadCheckShowList.length <= 0) {
					this.$message.warning("请选择要展示的指标");
					return;
				}
				this.tHeadCheckedList = JSON.parse(JSON.stringify(this.tHeadCheckShowList));
				localStorage.removeItem(this.getTHeadStorageKey());
				localStorage.setItem(this.getTHeadStorageKey(), JSON.stringify(this.tHeadCheckedList))
				this.$message.success("保存成功");
				this.closeTHeadDialog();
			},
			// 单个选中
			checkChange(e, index, items, indexs) {
				if (e === true) {
					this.tHeadCheckShowList.push(items)
				} else {
					const idx = this.tHeadCheckShowList.findIndex(item => item.label === items.label);
					if (idx !== -1) {
						this.tHeadCheckShowList.splice(idx, 1);
					}
				}
				// 更新分组状态
				this.updateGroupState(index);
			},
			updateGroupState(groupIndex) {
				const group = this.tHeadAllList[groupIndex];
				if (!group) return;
				const list = group.list;
				const checkedCount = list.filter(item => item.checked).length;
				const totalCount = list.length;
				// 更新全选状态
				group.groupChecked = checkedCount === totalCount;
				// 更新半选状态
				group.isIndeterminate = checkedCount > 0 && checkedCount < totalCount;
			},
			// 分组选中
			handleGroupCheckChange(e, item, index) {
				item.isIndeterminate = false;
				if (e === true) {
					// 将 item.list 下的所有对象 checked 设为 true
					item.list.forEach(listItem => {
						this.$set(listItem, 'checked', true);
					});
					// 去重版本的合并
					const newItems = item.list.filter(newItem =>
						!this.tHeadCheckShowList.some(existingItem => existingItem.label === newItem.label)
					);
					this.tHeadCheckShowList = this.tHeadCheckShowList.concat(newItems);
				} else {
					const labelsToRemove = item.list.map(items => items.label);
					this.tHeadCheckShowList = this.tHeadCheckShowList.filter(item1 => !labelsToRemove.includes(item1.label));
					// 可选：取消分组选中时也将 checked 设为 false
					item.list.forEach(listItem => {
						this.$set(listItem, 'checked', false);
					});
				}
			},
			// 删除check-box的选中
			deleteTHeadChecked(item, index) {
				let foundGroupIndex = -1;
				// 遍历每个分类
				this.tHeadAllList.forEach((category, categoryIndex) => {
					// 在当前分类的 list 中查找匹配的项
					const foundItem = category.list.find(items => items.label === item.label);
					if (foundItem) {
						this.$set(foundItem, 'checked', false);
						// 记录找到的分组索引
						foundGroupIndex = categoryIndex;
					}
				});
				this.tHeadCheckShowList.splice(index, 1);

				// 如果找到了对应的分组，更新该分组的状态
				if (foundGroupIndex !== -1) {
					this.updateGroupState(foundGroupIndex);
				}
			},
			handleDragStart(e, item) {
				this.dragging = item.label;
			},
			handleDragEnd(e, item) {
				this.dragging = null
			},
			//首先把div变成可以放置的元素，即重写dragenter/dragover
			handleDragOver(e) {
				e.dataTransfer.dropEffect = 'move' // e.dataTransfer.dropEffect="move";//在dragenter中针对放置目标来设置!
			},
			handleDragEnter(e, item) {
				e.dataTransfer.effectAllowed = "move";
				// 如果拖拽目标是自身，则不处理
				if (item.label === this.dragging) {
					return;
				}
				try {
					const newItems = [...this.tHeadCheckShowList];
					// 查找源元素和目标元素的位置
					const src = newItems.findIndex(i => i.label === this.dragging);
					const dst = newItems.findIndex(i => i.label === item.label);
					// 验证索引有效性
					if (src === -1) {
						console.warn(`找不到源元素: ${this.dragging}`);
						return;
					}
					if (dst === -1) {
						console.warn(`找不到目标元素: ${item.label}`);
						return;
					}
					// 如果源和目标相同，不处理
					if (src === dst) {
						return;
					}
					// 移动元素
					const [movedItem] = newItems.splice(src, 1);
					newItems.splice(dst, 0, movedItem);
					this.tHeadCheckShowList = newItems;
				} catch (error) {
					console.error('拖拽操作出错:', error);
				}
			}
		},
	}
</script>

<style scoped>
	.mianPage {
		padding: 10px;
	}

	.topSearch {
		background: #ffffff;
		padding: 16px;
		padding-bottom: 6px;
	}

	.el-form {
		flex-wrap: wrap;
	}

	/deep/ .el-form-item {
		margin-right: 10px !important;
		margin-bottom: 10px;
	}

	/deep/ .icon-no .el-table__expand-icon {
		display: none;
	}

	/deep/ .el-form-item__content {
		line-height: 32px;
	}
	
	.searchMenuRight{
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		height: 82px;
	}


	.tableBox {
		margin-top: 10px;
		background: #ffffff;
		padding: 16px;
	}

	.tableBtns {
		height: 32px;
		margin-left: auto;
	}

	.tHeadRow {
		align-items: center;
		margin-bottom: 20px;
	}

	.tHeadleftTips {
		font-size: 12px;
		margin-right: 20px;
	}

	.setLabel {
		margin-left: 10px;
		font-size: 30px;
		cursor: pointer;
	}

	.cardTitle {
		font-weight: 500;
		font-size: 22px;
		color: #000000;
		align-items: center;
	}

	.cardTitle i {
		cursor: pointer;
	}

	.cardTitleTxt {
		font-size: 16px;
	}

	.box-card {
		height: 100%;
		overflow-y: auto;
	}

	.box-card /deep/ .el-form--inline .el-form-item {
		display: block !important;
	}

	.card-bottom {
		/* padding-right: 30px; */
		margin-top: 30px;
	}



	.query-menu-right {
		margin-left: auto;
		margin-bottom: 10px;
	}



	.pageTopBox {
		height: 54px;
		width: 100%;
		/* border-left: 3px solid #4568dc; */
		box-shadow: 0 3px 15px rgb(0 0 0 / 5%);
		padding: 0 20px;
		box-sizing: border-box;
		background: #FFFFFF;
		align-items: center;
	}

	.addBtn {
		padding-right: 5px;
	}

	.titleText {
		font-family: PingFang SC, PingFang SC;
		line-height: 54px;
		font-weight: 500;
		font-size: 18px;
		color: #333333;
	}

	.crumbsText {
		margin-left: auto;
		font-size: 14px;
		line-height: 54px;
		cursor: pointer;
		color: #4568dc;
	}

	.crumbsText span {
		color: #6c757d;
		cursor: auto;
	}

	/deep/.success-row {
		background-color: #EBFAFF !important;
	}

	.el_tables /deep/ tr {
		background-color: #F6FEFF !important;
	}

	.el_tables {
		font-size: 12px !important;
	}

	.el_table /deep/.el-table__expanded-cell {
		padding: 0 !important;
		padding-left: 50px !important;
		background-color: #F6FEFF !important;
		box-sizing: border-box !important;
	}

	.upload-demo {
		margin: 0 auto;
		margin-bottom: 10px;
	}

	.paging {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}


	.tHeadEditBox {
		border: 1px solid #C2CEDF;
		padding: 12px;
		box-sizing: border-box;
	}

	.tHeadAllList {
		width: 49%;
		height: 490px;
		overflow-y: auto;
	}

	.checkList {
		width: 100%;
		flex-wrap: wrap;
		/* padding-right: 15px; */
		box-sizing: border-box;
	}

	.el_check_box {
		margin-bottom: 15px;
		margin-right: 0;
		width: 50%;
	}

	/deep/.el-collapse-item__header {
		font-weight: 500;
		font-size: 14px;
		color: #333333;
	}

	/deep/.el-collapse-item__content {
		padding-bottom: 10px;
	}

	.tHeadCheckShowBox {
		width: 49%;
		background: #F0F2F5;
		padding: 16px 18px;
		box-sizing: border-box;
	}

	.tHeadCheckShowTitle {
		font-size: 14px;
		color: #4E5865;
	}

	.tHeadCheckShowTips {
		font-size: 12px;
		color: #8E98AA;
	}

	.tHeadCheckShowList {
		border: 1px solid #C3CDE0;
		border-bottom: none;
		margin-top: 8px;
		height: 420px;
		overflow-y: auto;
	}

	.tHeadCheckedOne {
		width: 100%;
		height: 34px;
		line-height: 34px;
		align-items: center;
		border-bottom: 1px solid #C3CDE0;
		padding: 0 8px;
		font-weight: 500;
		font-size: 14px;
		color: #4E5866;
		box-sizing: border-box;
		cursor: pointer;
	}

	.tHeadCheckedOne div {
		margin-left: 4px;
	}
	
	.tHeadCheckedOne img {
		width: 16px;
		height: 16px;
	}

	.tHeadCheckedOne i {
		font-size: 18px;
	}

	.tHeadFixedCheckList {
		flex-wrap: wrap;
		width: 50%;
	}

	.check-box-fixed {
		/* margin-bottom: 10px; */
	}

	/deep/.appNameIdOptions .el-select-dropdown__item {
		height: 48px !important;
		line-height: 48px !important;
	}

	.selectTemp2 {
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	.selectAppName,
	.selectAppId {
		font-size: 12px;
		color: #333333;
		line-height: 20px;
	}

	.selectAppId {
		color: #999999;
		align-items: center;
	}

	.selectAppId img {
		width: 14px;
		height: 14px;
		margin-left: 3px;
	}

	.dimensionalityCheckedTips {
		align-items: center;
		padding: 0 12px;
		height: 30px;
		background: rgba(0, 127, 255, 0.1);
		border-radius: 2px;
		border: 1px solid rgba(0, 127, 255, 0.2);
		box-sizing: border-box;
		font-weight: 500;
		font-size: 12px;
		color: #333333;
		margin-bottom: 16px;
	}

	.dimensionalityCheckedTips img {
		width: 16px;
		height: 16px;
		margin-right: 2px;
		cursor: pointer;
	}
</style>
